<div class="reservation-confirmation h100 w100">
  <div class="reservation-confirmation__admin-msgs"
    *ngIf="this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationMessage && !reservationCancelled">
    <em class="icon-Info reservation-confirmation__info-icon"></em>
    <span *ngIf="isConfirmationMsgHTML"
      [innerHTML]="this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationMessage"></span>
    <span
      *ngIf="!isConfirmationMsgHTML">{{this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationMessage}}</span>
  </div>
  <div class="reservation-confirmation__confirmation-details"
    [ngClass]="{'reservation-confirmation__confirmation-details-disclaimer': this.ls.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationMessage,'reservation-confirmation__no-image-view':showImage}">
    <div class="reservation-confirmation__message-section"
      [ngClass]="{'reservation-confirmation__width-without-illustration': showImage}">
      <div class="reservation-confirmation__message-holder"
        [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentTopBackgroundColor}">
        <div class="reservation-confirmation__title confirmation-title">
          {{rs.reservationConfirmationText | translate}}
        </div>
        <div class="reservation-confirmation__reservation-details">
          <div class="reservation-confirmation__reservation-info">
            <span class="default-sub-header">{{ls.restaurantWidgetSettings$.value.PropertyType | translate}}</span>
            <span class="reservation-summary">{{ls.restaurantWidgetSettings$.value.RestaurantName}}</span>
          </div>
          <div class="reservation-confirmation__reservation-info reservation-confirmation__date">
            <span class="default-sub-header">{{'date' | translate}}</span>
            <span class="reservation-summary">{{reservationFor | formatSettingsDate:
              ls.restaurantWidgetSettings$.value.DateFormat}}</span>
          </div>
          <div class="reservation-confirmation__reservation-info reservation-confirmation__time">
            <span class="default-sub-header">{{'time' | translate}}</span>
            <span class="reservation-summary">{{reservationFor | localizeDate: 'LT'}}</span>
          </div>
          <div class="reservation-confirmation__reservation-info">
            <span class="default-sub-header">{{'partySize' | translate}}</span>
            <span class="reservation-summary">{{partySize}}</span>
          </div>
          <div class="reservation-confirmation__actions" *ngIf="!reservationCancelled">
            <app-button [buttontype]="modifyBtn" (valueChange)="modifyReservation($event)"></app-button>
            <app-button [buttontype]="additionalGuestBtn"
              *ngIf="rs.additionalGuestRequired > 0 && rs.additionalGuestPage && ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowAdditionalGuestDetails"
              (valueChange)="additionalGuest($event)"></app-button>
            <app-button [buttontype]="cancelBtn" (valueChange)="cancelReservation($event)"></app-button>
          </div>
        </div>
      </div>
      <div class="reservation-confirmation__illustration"
        [ngClass]="{'reservation-confirmation__width-without-illustration': showImage}">
        <div class="reservation-confirmation__payment-summary" *ngIf="totalAmount >0 && !reservationCancelled"
          [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
          <div class="page-title reservation-confirmation__payment-summary-title">{{'PaymentSummary' | translate}}</div>

          <div class="reservation-confirmation__payment-details">

            <div class="reservation-confirmation__payment-info"
              *ngIf="specialMealName && specialMealAmount > 0 && !selectedMeal">
              <span class="reservation-confirmation__payment-data default-sub-header">{{specialMealName}}</span>
              <span class="property-content">{{ls.restaurantWidgetSettings$.value.OperationCurrency}}
                {{specialMealAmount
                | currencyDecimalFormatter}}</span>
            </div>

            <div
              *ngIf="specialMealName && specialMealAmount >0  && selectedMeal && ls.editPartyData$.value.CoverTypeQuantities">
              <span class="reservation-confirmation__payment-info default-sub-header">{{specialMealName}}</span>
              <div class="reservation-confirmation__cover-type-data"
                *ngIf="ls.editPartyData$.value.CoverTypeQuantities.length > 0">
                <div class="reservation-confirmation__cover-type-name default-sub-header"
                  *ngFor="let coverType of ls.editPartyData$.value.CoverTypeQuantities">
                  <span>{{coverType.Covers}} x {{coverType.CoverTypeName}}</span>
                  <span class="property-content">{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{selectedMeal
                    |
                    coverTypePriceFilter: coverType | currencyDecimalFormatter}}</span>
                </div>
              </div>
            </div>

            <div class="reservation-confirmation__payment-info" *ngIf="ratePlanAmount > 0">
              <span class="reservation-confirmation__payment-data default-sub-header">{{seatingTypeName}}</span>
              <span class="property-content">{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{ratePlanAmount |
                currencyDecimalFormatter}}</span>
            </div>

            <div class="reservation-confirmation__payment-info"
              *ngIf="!(ratePlanAmount>0) && !(specialMealAmount>0) && noShowFeeAmount > 0 ">
              <span class="default-sub-header">{{'noShowFee' | translate}}</span>
              <span class="property-content">{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{noShowFeeAmount
                |
                currencyDecimalFormatter}}</span>
            </div>




            <div *ngIf="taxAmount || serviceCharge" class="reservation-confirmation__divider"></div>
            <div *ngIf="taxAmount || serviceCharge" class="reservation-confirmation__payment-info payment-summary mb-0">
              <span>{{'SubTotal' | translate}}</span>
              <span>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{ subTotal | currencyDecimalFormatter}} </span>
            </div>

            <div *ngIf="taxAmount"
              class="reservation-confirmation__payment-info payment-summary reservation-confirmation__tax-section mb-0">
              <div class="reservation-confirmation__tax-amount">
                <span>{{'taxAmount' | translate}}</span>
                <span>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{taxAmount | currencyDecimalFormatter}}</span>
              </div>
              <!-- Needed for future enhancement -->
              <!-- <div class="reservation-confirmation__tax-details">
              <span>{{'details' | translate}}<span class="icon-Right-Arrow reservation-confirmation__expand-details" (click)="showTaxes()"></span>
    </span>

              <div *ngIf="showTaxDetails" class="reservation-confirmation__tax-view-container" [ngStyle]="{'height': showTaxDetails ? 'auto' : 0 }">
                <div *ngFor="let tax of taxes" class="reservation-confirmation__tax-view">
                  <span>{{tax.TaxName}}</span>
                  <span>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{tax.TaxAmount | currencyDecimalFormatter}}</span>
                </div>
              </div>
            </div> -->
            </div>
            <div *ngIf="serviceCharge"
             class="reservation-confirmation__payment-info payment-summary reservation-confirmation__tax-section mb-0">
              <div class="reservation-confirmation__tax-amount">
                <span>{{'serviceCharges' | translate}}</span>
                <span>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{serviceCharge | currencyDecimalFormatter}}</span>
              </div>
            </div>
            <div *ngIf="serviceChargeTax"
              class="reservation-confirmation__payment-info payment-summary reservation-confirmation__tax-section">
              <div class="reservation-confirmation__tax-amount">
                <span>{{'taxOnserviceCharge' | translate}}</span>
                <span>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{serviceChargeTax | currencyDecimalFormatter}}</span>
              </div>
            </div>
            <div *ngIf="taxAmount || serviceCharge" class="reservation-confirmation__divider"></div>
            <div *ngIf="taxAmount || serviceCharge" class="reservation-confirmation__content-summary payment-summary">
              <span>{{'grandTotal' | translate}}
                <span>{{'inclTaxes' | translate}}</span>
              </span>
              <span>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{totalAmount | currencyDecimalFormatter}} </span>
            </div>
            <div *ngIf="!(taxAmount || serviceCharge)" class="reservation-confirmation__content-summary payment-summary">
              <span>{{'totalAmount' | translate}}</span>
              <span>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{totalAmount | currencyDecimalFormatter}} </span>
            </div>

          </div>

        </div>
        <div class="reservation-confirmation__cancelled-view" *ngIf="reservationCancelled"
          [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
          <div class="reservation-confirmation__header-data">{{'guestInfo' | translate}}</div>
          <div class="reservation-confirmation__guest-info">
            <div class="reservation-confirmation__guest-name">
              <span class="default-sub-header">{{'name' | translate}}</span>
              <span class="reservation-summary">{{ls.editPartyData$.value.Contact.FirstName}}
                {{ls.editPartyData$.value.Contact.LastName}}</span>
            </div>
            <div class="reservation-confirmation__email">
              <span class="default-sub-header">{{'emailText' | translate}}</span>
              <span class="reservation-summary">{{ls.editPartyData$.value.Contact.EmailAddress}}</span>
            </div>
            <div class="reservation-confirmation__phone">
              <span class="default-sub-header">{{'phoneText' | translate}}</span>
              <span class="reservation-summary">{{ls.editPartyData$.value.Contact.PhoneNumber}}</span>
            </div>
            </div>
            <div class="reservation-confirmation__header-data">{{'reservationInfo' | translate}}</div>
            <div class="reservation-confirmation__reservation-info">
              <div class="reservation-confirmation__property">
                <span class="default-sub-header">{{ls.restaurantWidgetSettings$.value.PropertyType | translate}}</span>
                <span class="reservation-summary">{{ls.restaurantWidgetSettings$.value.RestaurantName}}</span>
              </div>
              <div class="reservation-confirmation__phone-data">
                <span class="default-sub-header">{{'phoneText' | translate}}</span>
                <span class="reservation-summary">{{ls.restaurantWidgetSettings$.value.PhoneNumber}}</span>
              </div>
              <div class="reservation-confirmation__address">
                <span class="default-sub-header">{{'address' | translate}}</span>
                <span
                  class="reservation-summary">{{ls.restaurantWidgetSettings$.value.Street1}}{{ls.restaurantWidgetSettings$.value.Street2}},
                  {{ls.restaurantWidgetSettings$.value.City}}, {{ls.restaurantWidgetSettings$.value.Country}}</span>
              </div>
            </div>
          </div>
        </div>
        <app-button [buttontype]="bookNewReservation" (valueChange)="bookReservation($event)"></app-button>
      </div>
    </div>